module.exports = __webpack_public_path__ + "img/case_1.baae27fe.png";